<div>
  <kl-program-qa-form (postCreated)="onPostCreated($event)"></kl-program-qa-form>
</div>
